import { Collection } from "../ports.js";
/** Offers to work this phone received and sent, over the Storage port. Never leaves the phone. */
export class OfferStore {
    storage;
    constructor(storage) {
        this.storage = storage;
    }
    received() {
        return this.storage.list(Collection.workOffers);
    }
    receivedOn(channel) {
        return this.storage.get(Collection.workOffers, channel);
    }
    saveReceived(o) {
        return this.storage.put(Collection.workOffers, o.channel, o);
    }
    removeReceived(channel) {
        return this.storage.delete(Collection.workOffers, channel);
    }
    sent() {
        return this.storage.list(Collection.offersSent);
    }
    saveSent(o) {
        return this.storage.put(Collection.offersSent, o.channel, o);
    }
}
//# sourceMappingURL=store.js.map